import { useSearchParams } from "react-router-dom";
import AngularRootApp from "../../AngularRootApp";
import { ResizeAwareDiv } from "../../common/components/ResizeablePanel";
import useClientConfig from "../../common/hooks/clientConfigHook";
import JobStats from "./JobStats";
import PCRStats from "./PCRStats";

const Stats = () => {
    const clientConfig = useClientConfig();
    const [searchParams] = useSearchParams();

    if (clientConfig.reactStatsDefault === true || searchParams?.get('react')) {
        return <ResizeAwareDiv>
                { clientConfig.epcrOnly ? <PCRStats></PCRStats> : <JobStats></JobStats> }
        </ResizeAwareDiv>
    } else {
        return <AngularRootApp key="stats" template="<stats></stats>"></AngularRootApp>;
    }
}

export default Stats;